<template>
  <div class="form_usuario">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout style="display: unset;">
          <v-tabs
            slider-color="indigo darken-4"
            left
            v-model="currentItemModal"
            id="containerTab"
            class="tabPerfil certificado panelEmpresa"
            color="grey lighten-5"
          >
            <v-tab
              id="tabOption"
              v-for="(item,i) in tabsModal"
              :key="i"
              :class="[i == currentItemModal ? 'active' : '']"
            >{{ item.title }}</v-tab>

            <v-tab-item>
              <v-card v-show="this.currentItemModal == 0">
                <v-card-text>
                  <v-layout row wrap class="form_empresa_inputs">
                    <v-flex
                      :class="[displayFlex, item.class]"
                      v-for="(item,i) in modelForm.form.items"
                      :key="i"
                      v-if="item.type == 'T' && (prodRural && item.text != 'CNPJ' || !prodRural && item.text != 'CPF')"
                    >
                      <v-text-field
                        :maxLength="item.item_id == 'apelido' && 10"
                        color="teal"
                        v-model="item.valor"
                        :prepend-icon="item.prepIcon"
                        :mask="!edit ? item.mask : item.item_id == 'cnpj' ? item.valor && item.valor.length > 11 ? item.maskCNPJ.v : item.maskCPF.v : ''"
                        @keyup="item.item_id == 'cnpj' ? trocaCampoCpfCnpj($event, item) : ''"
                        validate-on-blur
                        @keydown.delete="item.item_id == 'cnpj' ? item.mask = '' : ''"
                        :clearable="edit && item.item_id != 'cnpj' && item.item_id != 'razao' || !edit"
                        :ref="item.item_id"
                        @blur="item.item_id == 'cnpj' ? verificaCNPJ(item) : ''"
                        :rules="item.item_id == 'cnpj' ? item.valor && item.valor.length > 11 ? cnpjRules : item.valor && item.valor.length <= 11 && item.valor && item.valor.length > 0 ? cpfRules :  [ v => { return true}] 
                                : item.item_id == 'razao' ? razaoRules : [ v => { return true}]"
                        :disabled="edit && item.item_id == 'cnpj'"
                      >
                        <template slot="label">{{item.text}}:</template>
                      </v-text-field>
                    </v-flex>

                    <v-flex
                      :class="[displayFlex, item.class]"
                      v-for="(item,i) in modelForm.form.items"
                      :key="i"
                      v-if="item.type == 'S'"
                    >
                      <v-autocomplete
                        v-model="item.valor"
                        :items="item.options"
                        persistent-hint
                        color="teal"
                        :prepend-icon="item.prepIcon"
                        no-data-text="Erro na consulta de dados"
                        return-object
                        :multiple="item.multiple"
                      >
                        <template slot="label">
                          <small>{{item.text}}:</small>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex :class="displayFlex">
                      <v-autocomplete
                        v-model="uf"
                        item-text="nome"
                        :items="arrayEstados"
                        label="Estado:"
                        class="input-required"
                        persistent-hint
                        :disabled="edit"
                        color="teal"
                        prepend-icon="place"
                        :rules="this.razaoRules"
                        no-data-text="Consulta de Estado indisponível"
                        return-object
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex :class="displayFlex">
                      <v-autocomplete
                        v-model="municipio"
                        item-text="nome"
                        :items="arrayCidades"
                        label="Cidade:"
                        color="teal"
                        class="input-required"
                        :rules="this.razaoRules"
                        persistent-hint
                        return-object
                        prepend-icon="place"
                        no-data-text="Selecione um Estado"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card v-show="this.currentItemModal == 1">
                <v-card-text>
                  <v-flex :class="displayFlex">
                    <v-tabs
                      slider-color="indigo darken-4"
                      left
                      v-model="currentItem"
                      id="containerTab"
                      class="tabPerfil certificado"
                      color="grey lighten-5"
                    >
                      <v-tab
                        id="tabOption"
                        v-for="(item,i) in tabs"
                        :key="i"
                        :class="[i == currentItem ? 'active' : '']"
                      >{{ item.title }}</v-tab>
                      <v-tab-item>
                        <v-card v-show="this.currentItem == 0">
                          <v-card-text>
                            <FormCertificado
                              :conta="this.conta"
                              :formEmp="true"
                              :displayFlex="'xs12 sm12 md12'"
                              :vincular="false"
                              :create="true"
                              :resetForm="this.resetFormCert"
                              :getDadosForm="this.getDadosCert"
                              @changResetForm="changResetForm($event)"
                              @emitDadosForm="emitDadosForm($event)"
                            ></FormCertificado>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item>
                        <v-card v-show="this.currentItem == 1">
                          <v-card-text>
                            <FormCertificado
                              :conta="this.conta"
                              :displayFlex="'xs12 sm12 md12'"
                              :vincular="true"
                              :create="false"
                              :resetForm="this.resetFormCert"
                              :getDadosForm="this.getDadosCert"
                              @changResetForm="changResetForm($event)"
                              @emitDadosForm="emitDadosForm($event)"
                            ></FormCertificado>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat v-if="this.currentItemModal == 2">
                <v-card-text style="background-color: #e9e9e9;">
                  <TabNotificacoes :notificacoes="this.notificacoes"></TabNotificacoes>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import FormEmpresa from "@/domain/conta/empresa/FormEmpresa.js";
import EmpresasService from "@/domain/conta/empresa/EmpresaService.js";
import FormCertificado from "@/components/conta/empresa/certificado/formCertificado/FormCertificado.vue";
import TabNotificacoes from "@/components/conta/empresa/formEmpresa/tabNotificacoes/TabNotificacoes.vue";
export default {
  props: [
    "displayFlex",
    "create",
    "edit",
    "getDadosForm",
    "resetForm",
    "empEdit",
    "conta",
    "currentTab",
    "IBGE",
    "notificacoes"
  ],
  components: {
    FormCertificado: FormCertificado,
    TabNotificacoes: TabNotificacoes
  },
  data() {
    return {
      valid: true,
      currentItem: 0,
      tabs: [
        {
          title: "Cadastrar novo"
        },
        {
          title: "Vincular um previamente cadastrado"
        }
      ],
      prodRural: false,
      currentItemModal: 0,
      tabsModal: [
        {
          title: "Informações"
        },
        {
          title: "Certificado"
        },
        {
          title: "Notificações"
        },
      ],
      cpfRules: [
        v => !!v || "Campo obrigatório",
        cpf => {
          let sum, rest;
          if (
            cpf === undefined ||
            cpf === null ||
            cpf.trim().length === 0 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999"
          ) {
            return "CPF inválido";
          }
          cpf = cpf
            .replace(".", "")
            .replace(".", "")
            .replace("-", "");

          sum = 0;
          for (let i = 1; i <= 9; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
          }
          rest = (sum * 10) % 11;

          if (rest === 10 || rest === 11) {
            rest = 0;
          }
          if (rest !== parseInt(cpf.substring(9, 10))) {
            return "CPF inválido";
          }

          sum = 0;
          for (let i = 1; i <= 10; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
          }
          rest = (sum * 10) % 11;

          if (rest === 10 || rest === 11) {
            rest = 0;
          }
          if (rest !== parseInt(cpf.substring(10, 11))) {
            return "CPF inválido";
          }
          return true;
        }
      ],

      cnpjRules: [
        v => !!v || "Campo obrigatório",
        v => {
          if (v == null) {
            return false;
          }
          var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

          if ((v = v.replace(/[^\d]/g, "")).length != 14)
            return "CNPJ inválido";

          if (/0{14}/.test(v)) return "CNPJ inválido";

          for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]);
          if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

          for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]);
          if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

          return true;
        }
      ],
      razaoRules: [v => !!v || "Campo obrigatório"],
      modelForm: new FormEmpresa(),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menuCte1: false,
      menuCte2: false,
      menuCte3: false,
      menuCte4: false,
      show1: false,
      show2: false,
      show3: false,
      trocaCPFCNPJ: false,
      getDadosCert: false,
      arrayEstados: [],
      arrayCidades: [],
      uf: "",
      municipio: "",
      logConsulta: "",
      route: this.$router.history.current.path,
      resetFormCert: false
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getEstados;
      this.service = new EmpresasService(this.$http);
    });
  },
  updated: function() {},
  watch: {
    "IBGE.cidades.items": function(newV, oldV) {
      if (newV != oldV) {
        this.arrayCidades = newV;
      }
    },
    "IBGE.estados": function(newV, oldV) {
      if (newV != oldV) {
        this.arrayEstados = newV;
      }
    },
    currentTab: function(newV, oldV) {
      this.currentItemModal = newV;
    },
    resetForm: function(newV, oldV) {
      if (this.resetForm) {
        this.resetarForm();
      }
    },
    edit: async function() {
      this.resetarForm();

      if (this.edit && this.empEdit.hasOwnProperty("cnpj")) {
        new Promise(async (resolve, reject) => {
          await this.$refs.form.reset();
          setTimeout(() => {
            resolve();
          }, 1000);
        }).then(() => {
          let auxEmpEdit = this.empEdit;
          for (var prop in this.empEdit) {
            this.modelForm.form.items.forEach(item => {
              if (item.item_id == prop) {
                item.valor = auxEmpEdit[prop];
              }
            });
          }
          let auxUf = this.empEdit.uf;
          let auxEstado;
          this.arrayEstados.forEach(item => {
            if (item.id == auxUf) {
              auxEstado = item;
            }
          });
          this.uf = auxEstado;
          this.municipio = this.empEdit.municipio;
          this.resetFormCert = true;
          if (this.empEdit.cnpj.length > 11) {
            this.prodRural = false;
          } else if (this.empEdit.cnpj.length == 11) {
            this.prodRural = true;
          }
        });
      }
    },
    uf: function() {
      this.getCidades();
    },
    getDadosForm: function(newV, oldV) {
      if (newV) {
        this.getDadosCert = true;
      }
    }
  },
  computed: {
    getEstados: async function() {
      this.arrayEstados = this.IBGE.estados;
    }
  },
  methods: {
    trocaCampoCpfCnpj: function(e, obj) {
      if (!obj.valor || obj.valor.length == 0) {
        //qnd o campo estiver em branco tirar regra da mascara para possivel CTRL + V do usuário
        obj.mask = "";
      } else {
        if (this.trocaCPFCNPJ && obj.valor && obj.valor.length >= 12) {
          //Trocar para mask cnpj
          obj.mask = obj.maskCNPJ.v;
        } else if (obj.valor && obj.valor.length >= 11) {
          //Trocar para mascara flexivel em receber mais 1 caractere.
          this.trocaCPFCNPJ = true;
          obj.mask = "###.###.###-###";
        } else {
          //Trocar para mascara de cpf
          this.trocaCPFCNPJ = false;
          obj.mask = obj.maskCPF.v;
        }
      }
    },
    resetarForm: function() {
      if (!this.edit) {
        this.$refs.form.reset();
        this.currentItemModal = 0;
        this.resetFormCert = true;
        this.$emit("changResetForm", false);
      }
    },
    verificaCNPJ(item) {
      // success.body.nome  success.body.cep success.body.logradouro success.body.municipio success.body.uf
      if (this.$refs.cnpj[0].valid) {
        if(item.valor.length > 14) {
          item.valor = item.valor.split('/').join('');
        }
        item.valor = item.valor.split('.').join('');
        item.valor = item.valor.split('-').join('');
        this.service
          .getEmpresasCnpj(item.valor)
          .then(
            success => {
              // trocar para algo melhor
              if (this.cnpjRules[this.cnpjRules.length - 1].name.length != 0) {
                this.cnpjRules.pop();
              }
              if (this.cpfRules[this.cpfRules.length - 1].name.length != 0) {
                this.cpfRules.pop();
              }
              if (success && success.status != 404) {
                this.cnpjRules.push(function indisponivel(value) {
                  if (
                    success.body.items.length > 0 &&
                    value == success.body.items[0].cnpj
                  ) {
                    return "CNPJ já utilizado no sistema";
                  }
                  return true;
                });
                this.cpfRules.push(function indisponivel(value) {
                  if (
                    success.body.items.length > 0 &&
                    value == success.body.items[0].cnpj
                  ) {
                    return "CPF já utilizado no sistema";
                  }
                  return true;
                });
              }
              this.$refs.cnpj[0].validate();
              return this.$refs.cnpj[0].valid;
            },
            failed => {
              return failed;
            }
          )
          .then(cnpjValid => {
            if (cnpjValid) {
              this.service.getAPIReceita(item.valor).then(success => {
                if (
                  success &&
                  success.status == 200 &&
                  success.body.status != "ERROR"
                ) {
                  this.modelForm.form.items.forEach(item => {
                    if (item.item_id == "razao") {
                      item.valor = success.body.nome;
                    } else if (item.item_id == "cep") {
                      item.valor = success.body.cep;
                    } else if (item.item_id == "endereco") {
                      item.valor = success.body.logradouro;
                    } else if (item.item_id == "bairro") {
                      item.valor = success.body.bairro;
                    }
                  });
                  let auxEstado;
                  let auxCidade;
                  this.uf = this.arrayEstados.forEach(item => {
                    if (item.sigla == success.body.uf) {
                      auxEstado = item;
                    }
                  });
                  this.uf = auxEstado;
                  if (this.arrayCidades) {
                      if (success.body.municipio) {
                        this.municipio = this.arrayCidades.forEach(item => {
                          if (item.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "") == success.body.municipio.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9ÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÑÕÄËÏÖÜÇ]/ig, "")) {
                            console.log(item);
                            auxCidade = item;
                          }
                        });
                       
                      }
                    }
     
                  this.municipio = auxCidade
                }
              });
            }
          });
      }
    },
    emitDadosForm(cert) {
      if (this.$refs.form.validate() && this.getDadosForm) {
        let dados = {};
        this.modelForm.form.items.forEach(item => {
          if (
            item.valor != null &&
            item.valor != undefined &&
            item.valor != ""
          ) {      
            dados[item.item_id] = item.valor;
          }
        });
        this.uf != undefined && this.uf != "" && this.uf != null
          ? (dados["uf"] = this.uf.id)
          : (this.uf = undefined);
        this.municipio != undefined &&
        this.municipio != "" &&
        this.municipio != null
          ? (dados["municipio"] = this.municipio.nome)
          : (this.municipio = undefined);
        this.municipio != undefined &&
        this.municipio != "" &&
        this.municipio != null
          ? (dados["codMun"] = this.municipio.id)
          : (this.municipio = undefined);
       
        // dados["uf"] = this.uf;
        // dados["municipio"] = this.municipio;
        let obj = {};
        obj["dados"] = dados;
        obj["tipo"] = { component: "empresa" };
        obj["cert"] = cert;
        obj.tipo["acao"] = this.edit == true ? "edit" : "create";
        if (this.edit) {
          obj.dados["_id"] = this.empEdit._id;
        }
        this.getDadosCert = false;
        this.$emit("emitDadosForm", obj);
      } else if (!this.$refs.form.validate()) {
        this.getDadosCert = false;
        this.$emit("emitDadosForm", false);
      }
    },
    validateDate(field, item) {
      if (field.target.value.length == 10) {
        item.valor = field.target.value.split("-").join("");
        item.data = field.target.value
          .split("-")
          .reverse()
          .join("-");
      }
    },
    formatDate(date, menu) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}-${month}-${year}`;
    },
    getCidades: async function() {
      if (this.uf) {
        this.IBGE.cidades.uf = this.uf.id;
        this.IBGE.cidades.att = true;
      }
    },
    changResetForm(value) {
      this.resetFormCert = value;
    }
  },
  beforeMount: function() {
    this.$nextTick(function() {});
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
.fita {
  background: #009688;
  position: relative;
  margin: 20px auto;
  width: 85%;
  color: #fff;
  line-height: 32px;
  height: 32px;
  font-size: 16px;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  z-index: 2;
}
.auxFita {
  position: absolute;
  width: 85%;
  z-index: 2;
}
.auxFita:before,
.auxFita:after {
  content: "";
  line-height: 0;
  border-style: solid;
  border-width: 16px;
  position: absolute;
  top: 0.8cm;
  /* z-index: ; */
  width: 5px;
}
.auxFita:before {
  border-color: #56807c #56807c #56807c transparent;
  left: 28px;
}
.auxFita:after {
  border-color: #56807c transparent #56807c #56807c;
  right: -59px;
}
.conteudo:before,
.conteudo:after {
  position: absolute;
  content: "";
  height: 0;
  line-height: 1px;
  border-style: solid;
  border-width: 5px;
  z-index: 1;
}
.conteudo:before {
  border-color: #435a58 #435a58 transparent transparent;
  bottom: -10px;
  left: 0;
}
.conteudo:after {
  border-color: #435a58 transparent transparent #435a58;
  bottom: -10px;
  right: 0;
}
.form_empresa_inputs .v-input {
  font-size: 8px;
  margin-top: 10px;
}

.certificado .v-card__text {
}
</style> 



// WEBPACK FOOTER //
// src/components/conta/empresa/formEmpresa/FormEmpresa.vue